// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__EOIG7","emphasis":"Text_emphasis__1f1ly","alt":"Text_alt__15V7a","center":"Text_center__DJEWt","error":"Text_error__I1-be","success":"Text_success__3awRt"};